import { useNavigate, useSearchParams } from 'react-router-dom-v6'
import { Skeleton } from '@clouway/ui'

import { RoleEditor } from '../components/RoleEditor'
import { useCatalogRoles, useCreateRole, useProductStructure } from '../hooks'
import type { RoleInput } from '../types'

// /roles/new?product= — the product travels as a query param (not a route
// segment) since it's picked on the list page's selector, mirroring the
// Access tab's product-scoped reads rather than introducing a nested route.
export function RegisterRole() {
  const [searchParams] = useSearchParams()
  const product = searchParams.get('product') ?? ''
  const navigate = useNavigate()
  const { data: structure, isLoading: structureLoading } = useProductStructure(product)
  const { data: roles, isLoading: rolesLoading } = useCatalogRoles(product)
  const { mutateAsync: create } = useCreateRole(product)

  if (!product || structureLoading || rolesLoading || !structure) {
    return <Skeleton className="mx-auto h-80 w-full max-w-3xl" />
  }

  const onSubmit = async (input: RoleInput) => {
    await create(input)
    navigate('/roles', { replace: true })
  }

  const presets = (roles ?? []).filter((role) => !role.custom)

  return <RoleEditor structure={structure} presets={presets} mode="create" onSubmit={onSubmit} />
}
